const state = {
  orgId: [],
  orgLevel: '',
  orgDevice: []
};

const mutations = {
  // 设置当前所选组织id
  setOrgId: (state, value) => {
    console.log('setOrgId---', value);
    state.orgId = value;
  },
  // 设置当前所选组织是几级
  setLevel: (state, value) => {
    state.orgLevel = value;
  },
  // 设置组织机构所选部门设备数据
  setOrgDevice: (state, value) => {
    state.orgDevice = value;
  }
};

const actions = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
